module.exports = __webpack_public_path__ + "static/media/2. Cenizas, Óxidos_hierro, 12 x 45 cm, 2012 copy.2f4d0078.png";